import { GET } from "../../APiHelper/API";


export const getAvailableTeamsForLeagueAPI = (league_id, onSuccess, onError) => {
    GET(`/api/v1/leagues/${league_id}/teams`, onSuccess, onError)
}